/**
 * 会话状态 hook —— GET /api/v1/auth/me 是唯一身份来源(契约 me.ts:
 * cookie 是 HttpOnly,前端绝不读 storage 里的"登录态")。401 即匿名,
 * 其余错误按"未知/离线"处理(不冒充匿名,避免把已登录用户闪成游客 UI)。
 */
import { useCallback, useEffect, useState } from 'react';
import type { MeData } from '@web-v4/api-contract/v1/auth';
import { authClient } from './clients';

export type SessionState =
  | { readonly status: 'loading' }
  | { readonly status: 'anonymous' }
  | { readonly status: 'authed'; readonly me: MeData }
  | { readonly status: 'error' };

export interface Session {
  readonly state: SessionState;
  /** 重新查询 /auth/me(登录/登出等改变会话的动作之后调用)。 */
  readonly refresh: () => void;
}

export function useSession(): Session {
  const [state, setState] = useState<SessionState>({ status: 'loading' });
  const [tick, setTick] = useState(0);
  const refresh = useCallback(() => setTick((n) => n + 1), []);

  useEffect(() => {
    let cancelled = false;
    authClient
      .me()
      .then((me) => {
        if (cancelled) {
          return;
        }
        setState(me === null ? { status: 'anonymous' } : { status: 'authed', me });
      })
      .catch(() => {
        if (!cancelled) {
          setState({ status: 'error' });
        }
      });
    return () => {
      cancelled = true;
    };
  }, [tick]);

  return { state, refresh };
}
